
import React, { useState, useEffect } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import moment from "moment";
import data from "../../Utils/DataSamples/SampleWorkflowItems.json";
import { Link } from "react-router-dom";
import axios from "axios";
import { getCookie } from "../../services/DataRequestService";
import Loader from "../common/Loader";
import { get_workflows } from "../../services/ApiManageWorkflow";


function WorkFlowsData({ PathName }) {



    const prepDateFormat = (date) => {

        if (date === null) {
            return "";
        } else {
            return moment(date, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("Do MMM YYYY");
        }
    };

    const [workFlowdata, setWorkFlowData] = useState([])
    const [masterWorkFlowdata, setMasterWorkFlowdata] = useState([])
    const [workFlowPageData, setWorkFlowPageData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [customParams, setCustomParams] = useState({ redirectPath: "", fieldHeaderName: "", fieldValueName: "" });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

 
    // Calculate the total number of pages
    const totalPages = Math.ceil((workFlowdata?.length || 0) / itemsPerPage);

    // Get current page data
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = workFlowdata?.slice(indexOfFirstItem, indexOfLastItem) || [];



    useEffect(() => {
        getData(PathName);

        if (PathName === '/manageworkflow') {
            setCustomParams({ redirectPath: '/workflow', fieldHeaderName: 'Forecast Report', fieldValueName: 'Details' });
        } else if (PathName === "/comparison") {
            setCustomParams({ redirectPath: '/wf/comparison', fieldHeaderName: 'Compare', fieldValueName: 'Compare' });
        } else if (PathName === "/indentation") {
            setCustomParams({ redirectPath: '/indent', fieldHeaderName: 'Indentation', fieldValueName: 'View' });
        } else if (PathName === '/manageworkflow_disabled') {
            setCustomParams({ redirectPath: '/wf/detail-chart', fieldHeaderName: 'Forecast Report', fieldValueName: 'Details' });
        }
    }, [])

    useEffect(() => {
        const currentData = workFlowdata?.slice(indexOfFirstItem, indexOfLastItem) || [];
        setWorkFlowPageData(currentData);
    }, [currentPage])

    useEffect(() => {
        const updateStatusColors = () => {
            document.querySelectorAll("td.wfstatus").forEach((td) => {
                const text = td.textContent.trim().toLowerCase();
                if (text === "processing") {
                    td.style.color = "orange";
                } else if (text === "completed") {
                    td.style.color = "green";
                } else if (text === "pending") {
                    td.style.color = "orange";
                } else {
                    td.style.color = "black"; // Default color
                }
            });
        };

        const updateApprovalStatusColors = () => {
            document.querySelectorAll("td.wfapprovalstatus").forEach((td) => {
                const text = td.textContent.trim().toLowerCase();
                if (text === "processing") {
                    td.style.color = "orange";
                } else if (text === "approved") {
                    td.style.color = "green";
                } else if (text === "pending") {
                    td.style.color = "orange";
                } else {
                    td.style.color = "black"; // Default color
                }
            });
        };

        updateStatusColors();
        updateApprovalStatusColors();
    }, [workFlowdata])

    const getData = async (pathname) => {
        setIsLoading(true)
        try {
            let _response = await get_workflows(getCookie("sub"));
            if (pathname === "/comparison" || pathname === "/indentation") {
                _response = _response.filter(elem => elem?.status?.toLowerCase() === 'completed');
            }
            _response.reverse();
            // Handle the response
            setWorkFlowData(_response);
            setMasterWorkFlowdata(_response)
            const currentData = _response?.slice(indexOfFirstItem, indexOfLastItem) || [];
            setWorkFlowPageData(currentData);
        } catch (error) {
            // Handle errors
            console.error("Error fetching workflows:", error.message);
            throw error;
        }
        setIsLoading(false)
    }



    const searchByName = (name) => {
        if (name !== "") {
            const newData = workFlowdata.filter(workflow => workflow.workflow_name.toLowerCase().includes(name.toLowerCase()));
            setWorkFlowData(newData);
            const currentData = newData?.slice(indexOfFirstItem, indexOfLastItem) || [];
            setWorkFlowPageData(currentData);
        }
        else if (name === "") {
            setWorkFlowData(masterWorkFlowdata);
            const currentData = masterWorkFlowdata?.slice(indexOfFirstItem, indexOfLastItem) || [];
            setWorkFlowPageData(currentData);
        }
    }
    const searchByDate = (term) => {
        if (!term.trim()) {
            setWorkFlowData(masterWorkFlowdata); // Reset data if search is empty
            return;
        }

        const newData = workFlowdata.filter((item) =>
            prepDateFormat(item.process_date)
                .toLowerCase()
                .includes(term.toLowerCase())
        );
        setWorkFlowData(newData);
    }

    const reset = () => {
        setWorkFlowData(masterWorkFlowdata);
        const currentData = masterWorkFlowdata?.slice(indexOfFirstItem, indexOfLastItem) || [];
        setWorkFlowPageData(currentData);
        document.getElementById("workflowName").value = ""
       // document.getElementById("processDate").value = ""
    }

    // Function to handle page change
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    if (isLoading) {
        return <center className="mt-5"><Loader size={'large'} /></center>;
    }

    return (
        <>
            <div style={{ marginTop: "2vh" }} className="mycontainer manage-workflow-box">
            <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="createworkflowsection1">
                            <h4>Workflow Output</h4>
                            <p>You can view the list of workflows and there status here.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12  ">
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <div className="form-group1">
                                <label htmlFor="email">Search By Name</label>
                                <input
                                    onChange={(e)=>searchByName(e.target.value)}
                                    type="email"
                                    className="form-control"
                                    id="workflowName"
                                    placeholder="Search Here"
                                />
                                {/* <span className="cursor-pointer"> */}
                                <iconify-icon icon="material-symbols:search"></iconify-icon>
                                {/* </span> */}
                            </div>
                        </div>
                        {/* <div className="col-md-3 col-sm-6 col-xs-12">
                            <div className="form-group1">
                                <label htmlFor="email">Search By Process Date</label>
                                <input
                                    onChange={(e)=>searchByDate(e.target.value)}
                                    type="email"
                                    className="form-control"
                                    id="processDate"
                                    placeholder="like 21st"
                                />
                            </div>
                        </div> */}
                        <div className="flex items-center justify-center h-32">
                            <button 
                                onClick={() => reset()} 
                                style={{ marginTop: '8vh', padding: '14px', borderRadius: '5px' }}
                                className="px-4 py-2 text-white rounded bg-[#0C3C54]"
                            >
                                Reset Filter
                            </button>
                        </div>

                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-12 col-sm-12 col-xs-12  ">
                            <div className="table-responsive">
                                <table className="table dataselectiontable table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">Workflow Name</th>
                                            <th scope="col">Workflow Description</th>
                                            <th scope="col">Granularity</th>                                
                                            <th scope="col">Process Date</th>
                                            <th scope="col">Model Status</th>
                                            <th scope="col">Approval Status</th>
                                            <th scope="col">{customParams.fieldHeaderName}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!workFlowPageData || typeof data == "string" ? (
                                            <></>
                                        ) : (
                                            <>
                                                {workFlowPageData.map((elem, index) => (
                                                    <tr
                                                        key={index}
                                                        className={
                                                            102 == elem.workflow_id ? "highlight" : ""
                                                        }
                                                    >
                                                        <td>{elem.workflow_name}</td>
                                                        <td>{elem.workflow_description}</td>
                                                        <td>{elem.granularity}</td>
                                                        <td>{elem?.process_date?.split("T")[0]} </td>
                                                        <td className="wfstatus">{elem?.status}</td>
                                                        <td  className="wfapprovalstatus">{elem?.approval_status}</td>
                                                        <td className="details-link"> 
                                                            {elem?.status?.toLowerCase() === "completed" ? (
                                                                <Link
                                                                    to={customParams.redirectPath}
                                                                    state={{ workflow: elem }}
                                                                >
                                                                    {customParams.fieldValueName}
                                                                </Link>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Pagination Controls */}
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <center>
                            {totalPages > 1 && (
                                <nav aria-label="Page navigation">
                                    <ul className="pagination">
                                        {/* Previous Button */}
                                        <li
                                            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                            onClick={currentPage > 1 ? () => handlePageChange(currentPage - 1) : undefined}
                                        >
                                            <a className="page-link" href="#">Previous</a>
                                        </li>

                                        {/* Page Numbers */}
                                        {Array.from({ length: totalPages }, (_, i) => (
                                            <li
                                                key={i + 1}
                                                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                                onClick={() => handlePageChange(i + 1)}
                                            >
                                                <a className="page-link" href="#">{i + 1}</a>
                                            </li>
                                        ))}

                                        {/* Next Button */}
                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                            onClick={currentPage < totalPages ? () => handlePageChange(currentPage + 1) : undefined}
                                        >
                                            <a className="page-link" href="#">Next</a>
                                        </li>
                                    </ul>
                                </nav>

                            )}
                        </center>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WorkFlowsData;
